import {Module} from '@nestjs/common';
import {McpController} from './mcp.controller';
import {McpService} from './mcp.service';

/**
 * MCP 文件与系统操作模块
 */
@Module({
  controllers: [McpController],
  providers: [McpService],
  exports: [McpService],
})
export class McpModule {}
